import { Client } from '@/utils';
import { mineApply as mineApplyAPI } from '@/api';

const QUERY_AUTHORITY = 'authApply/QUERY_AUTHORITY';

export default {
  state:{
    tableData: [],
    totalRows: 0,
  },
  actions:{
    async [QUERY_AUTHORITY]({ commit }, { data = {}, frontCode = '' } = {}) {
      commit(QUERY_AUTHORITY, await Client.post(mineApplyAPI.queryAuthority, { data }, frontCode));
    },
  },
  mutations:{
    [QUERY_AUTHORITY](state,data) {
      state.tableData = data.content;
      state.totalRows = data.totalRows;
    },
  }
}




// WEBPACK FOOTER //
// ./src/store/modules/mineApply.js